import { useForm, Controller } from 'react-hook-form';
import { PopUpModal } from 'shared-components';
import TextField from 'components/common/textField';
import { ICreateSecret, ISecret } from 'interface/secretsInterface';
import { useAppSelector } from 'hooks/reduxHooks';
import { RootState } from 'redux-setup/store';

interface SecretFormProps {
  secret?: ISecret | null;
  onSubmit: (_data: ICreateSecret) => void;
  onClose: () => void;
}

export const SecretForm = ({ secret, onSubmit, onClose }: SecretFormProps) => {
  const organizationId = useAppSelector(
    (state: RootState) => state.organization.id,
  );

  const { control, handleSubmit } = useForm({
    defaultValues: {
      Scope: secret?.Scope || '',
      Key: secret?.Key || '',
      Value: secret?.Value || '',
    },
  });

  const onFormSubmit = (formData: {
    Scope: string;
    Key: string;
    Value: string;
  }) => {
    onSubmit({
      ...formData,
      OrganizationID: organizationId,
    });
  };

  return (
    <PopUpModal
      open={true}
      handleClose={onClose}
      heading={secret ? 'Edit Secret' : 'Add Secret'}
      buttons={[
        {
          buttonType: 'negative',
          buttonLabel: 'Cancel',
          buttonFunction: onClose,
        },
        {
          buttonType: 'positive',
          buttonLabel: 'Save',
          buttonFunction: handleSubmit(onFormSubmit),
        },
      ]}>
      <div className="popup-section">
        <form className="secret-form">
          <Controller
            name="Key"
            control={control}
            rules={{ required: 'Key is required' }}
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                label="Key"
                placeholder="Enter secret key"
                errorString={error?.message}
              />
            )}
          />

          <Controller
            name="Value"
            control={control}
            rules={{ required: 'Value is required' }}
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                label="Value"
                placeholder="Enter secret value"
                errorString={error?.message}
              />
            )}
          />

          <Controller
            name="Scope"
            control={control}
            rules={{ required: 'Scope is required' }}
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                label="Scope"
                placeholder="Enter secret scope"
                errorString={error?.message}
              />
            )}
          />
        </form>
      </div>
    </PopUpModal>
  );
};
